import React from "react";
import { List } from "../modules/Deposits";

export function DepositsPage() {
  return <List />;
}
